import { getCmsSpecialFareOffer } from "../../../app/api/getCmsSpecialFareOffer";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsSpecialFareOfferResponse } from "../../../Orchestrator/Types/Interface/ICMSOffers";

class GetCmsSpecialFareOfferAction extends BaseAction<ICmsSpecialFareOfferResponse | null, void> {
  override async run(): Promise<ICmsSpecialFareOfferResponse | null> {
    let result: ICmsSpecialFareOfferResponse | null = null

    try {
      const response = await getCmsSpecialFareOffer();

      if (response.status === "ok" && response.answer) {
        result = response.answer;
      } else {
        console.warn("Failed to fetch special fare offer.");
      }
    } catch {
      console.error("Failed to fetch special fare offer");
    } finally {
      updateRecoilState("cmsSpecialFareOfferResponseAtom", result);
      return result
    }
  }
}

export const getCmsSpecialFareOfferAction = new GetCmsSpecialFareOfferAction();
